import { useQuery } from '@tanstack/react-query';

import { readContentLanguages } from '../api/business/endpoints';
import type { AvailableLanguage } from '../api/business/types';

export type ContentLanguagesState = {
  /** In order, the default first; Slovak alone until the API has answered. */
  languages: Array<string>;
  available: Array<AvailableLanguage>;
  isLoading: boolean;
  error: unknown;
};

/** The languages the tenant writes its product texts in (ADR-0010 §2). */
export const useContentLanguages = (): ContentLanguagesState => {
  const query = useQuery({ queryKey: ['content-languages'], queryFn: readContentLanguages });

  return {
    languages: query.data?.languages ?? ['sk'],
    available: query.data?.available ?? [],
    isLoading: query.isLoading,
    error: query.error,
  };
};
